import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs as Primitive } from "radix-ui";
import { cn } from "../lib/cn.js";
/** Underlined tabs for the sections of a detail page. Keyboard: arrows move, Home/End jump. */
export const Tabs = Primitive.Root;
export function TabsList({ className, ...props }) {
    return (_jsx(Primitive.List, { className: cn("flex gap-1 overflow-x-auto border-b border-border", className), ...props }));
}
export function TabsTrigger({ className, ...props }) {
    return (_jsx(Primitive.Trigger, { className: cn("-mb-px inline-flex h-10 shrink-0 items-center gap-2 border-b-2 border-transparent px-3 text-sm font-medium whitespace-nowrap text-muted-foreground transition-colors outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring data-[state=active]:border-primary data-[state=active]:text-foreground [&_svg]:size-4", className), ...props }));
}
export function TabsContent({ className, ...props }) {
    return _jsx(Primitive.Content, { className: cn("pt-4 outline-none", className), ...props });
}
//# sourceMappingURL=tabs.js.map